<template>
  <div>
    <v-card
      elevation="5"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
        style="z-index: 2;"
      >
        <v-toolbar-title>Simulación</v-toolbar-title>
        <v-spacer />
        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-show="shouldShowTooltip"
              key="btn-action"
              :loading="isLoadingRequest"
              fab
              small
              v-bind="attrs"
              color="secondary"
              class="mr-2"
              v-on="on"
              @click.stop="handleSimulacionAction"
            >
              <v-icon
                color="primary"
              >
                {{ simulacionExists && simulacionSelected !== null ? 'mdi-eye' : 'mdi-plus' }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ simulacionExists && simulacionSelected !== null ? 'Mostrar simulación' : 'Generar simulación'
          }}</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-show="simulacionSelected || borrarError"
              key="btn-delete"
              fab
              small
              v-bind="attrs"
              color="secondary"
              v-on="on"
              @click.stop="deleteSimulacionButton()"
            >
              <v-icon
                color="primary"
              >
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Borrar simulación</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="simulaciones"
        disable-pagination
        hide-default-footer
        auto-resize
      >
        <template
          #item="{ item }"
        >
          <tr
            :class="{ 'selected-row': simulacionSelected && simulacionSelected.ID_SIMULACION === item.ID_SIMULACION }"
          >
            <td
              class="text-xs-left"
              style="width:10rem"
            >
              <template
                v-if="editableID === item.ID_SIMULACION"
              >
                <v-text-field
                  v-model="editableText"
                  dense
                  single-line
                  hide-details
                  autofocus
                  @blur="updateName(item)"
                  @keyup.enter="updateName(item)"
                />
              </template>
              <template
                v-else
              >
                <span
                  style="cursor: pointer"
                  @click="startEditing(item)"
                >
                  {{ item.NOMBRE ? item.NOMBRE : 'Sin nombre' }}
                </span>
              </template>
            </td>
            <td>{{ $date.formatDate(item.FECHA_CREACION, 'DD/MM/YYYY HH:mm') }}</td>
            <td>{{ $date.formatDate(item.FECHA_INICIO, 'DD/MM/YYYY HH:mm') }}</td>
            <td>{{ item.NUM_HORAS }}</td>
            <td>{{ item.INTERVALO }}</td>
            <td>
              <div
                class="d-flex align-center"
                style="gap: 4px; min-width: 72px;"
              >
                <v-btn
                  v-show="item.ESTADO === 'COMPLETED' || item.ESTADO === 'POSTPROCESSING'"
                  icon
                  color="primary"
                  @click.stop="selectSimulacion(item)"
                >
                  <v-icon>
                    {{ (simulacionSelected && simulacionSelected.ID_SIMULACION === item.ID_SIMULACION)
                      ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                  </v-icon>
                </v-btn>

                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      v-show="getStatusConfig(item.ESTADO).error"
                      icon
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="borrarSimulacionError(item)"
                    >
                      <v-icon>mdi-alert-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Error en la simulación. Click para borrar la simulacion e intente de nuevo</span>
                </v-tooltip>
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-progress-circular
                      v-show="estadoProgres(item) && !getStatusConfig(item.ESTADO).error"
                      v-bind="attrs"
                      :value="getStatusConfig(item.ESTADO).p"
                      :rotate="-90"
                      size="32"
                      width="4"
                      color="primary"
                      v-on="on"
                    >
                      <span
                        style="font-size: 8px;"
                      >
                        {{ getStatusConfig(item.ESTADO).p }}%
                      </span>
                    </v-progress-circular>
                  </template>
                  <span>Procesando...</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <template
        #no-data
      >
        <p>No hay datos de la simulación.</p>
      </template>
      <v-container
        v-show="shouldShowTooltip && simulacionSelected"
      >
        <v-row>
          <v-col
            v-for="(item, index) in buttons"
            :key="index"
          >
            <v-card
              class="pa-1"
              :disabled="showProgress || simulacionSelected?.ESTADO !== 'COMPLETED'"
              @click="handleButtonsMethod(item)"
            >
              <v-row
                align="center"
                class="pa-1"
              >
                <v-col
                  cols="auto"
                >
                  <v-icon
                    small
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-col>
                <v-col
                  cols="auto"
                  class="pa-0"
                >
                  {{ item.label }}
                </v-col>
                <v-col
                  class="d-flex justify-end pa-0 mr-2"
                >
                  <v-progress-circular
                    v-show="showProgress && item.action === itemAction && item.label === itemLabel"
                    color="primary"
                    indeterminate
                    :size="20"
                    :width="2"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- Snackbar error y success -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :top="true"
      :timeout="3000"
    >
      <v-icon>mdi-alert</v-icon>
      {{ snackbarText }}
    </v-snackbar>
    <v-snackbar
      v-model="isLoadingSimulacion"
      bottom
      :timeout="-1"
    >
      Cargando simulación...
      <template
        #action="{ attrs }"
      >
        <v-progress-circular
          indeterminate
          v-on="attrs"
        />
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="isErrorSimulacion"
      :color="errorSimulacion === 406 ? 'warning' : 'error'"
      bottom
      :timeout="3000"
    >
      <v-icon
        dark
      >
        mdi-alert-circle
      </v-icon>
      Advertencia en la simulación: {{ errorSimulacion === 404 ? 'no existe. En progreso o zona no combustible' :
        errorSimulacion === 406 ? 'en progreso' : 'error interno o simulación en zona no combustible' }}
    </v-snackbar>
  </div>
</template>
<script>
import * as ArcGIS from '@/helpers/ArcGIS'
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import DateService, { FMT } from '@/helpers/DateService'

export default {
  props: {
    idIncendio: { type: String, required: true }
  },

  data: () => ({
    headers: [
      { text: 'Nombre', value: 'NOMBRE', align: 'left', sortable: true },
      { text: 'Creación', value: 'FECHA_CREACION', align: 'left', sortable: true },
      { text: 'Inicio', value: 'FECHA_INICIO', align: 'left', sortable: true },
      { text: 'Horas', value: 'NUM_HORAS', align: 'left', sortable: false },
      { text: 'Intervalo', value: 'INTERVALO', align: 'left', sortable: false }
    ],
    buttons: [
      { label: 'KML', action: 'Download', icon: 'mdi-download', method: 'downloadSimulacionVector' },
      { label: 'SHP', action: 'Download', icon: 'mdi-download', method: 'downloadSimulacionVector' },
      { label: 'PDF', action: 'Download', icon: 'mdi-download', method: 'downloadSimulacionPDF' },
      { label: 'KML', action: 'Link', icon: 'mdi-link', method: 'downloadSimulacionVector' },
      { label: 'SHP', action: 'Link', icon: 'mdi-link', method: 'downloadSimulacionVector' }
    ],
    meteoData: [
      { ID: 'temperatura', VARIABLE: 'Temperatura', VALORES: [], DECIMALES: 0 },
      { ID: 'humedad_relativa', VARIABLE: 'Hum. Relativa (%)', VALORES: [], DECIMALES: 0 },
      { ID: 'nubosidad', VARIABLE: 'Nubosidad (%)', VALORES: [], DECIMALES: 0 },
      { ID: 'mod_viento', VARIABLE: 'Mod. Viento', VALORES: [], DECIMALES: 0 },
      { ID: 'dir_viento', VARIABLE: 'Dir. Viento', VALORES: [], DECIMALES: 0 },
      { ID: 'precipitaciones', VARIABLE: 'Precipitaciones (mm)', VALORES: [], DECIMALES: 0 }
    ],
    focos: [],
    sim: null,
    simulacionSelected: null,
    isErrorSimulacion: false,
    errorSimulacion: null,

    // Edición de nombre
    editableID: null,
    editableText: '',

    // Variables botones descarga y links
    showProgress: false,
    itemLabel: '',
    itemAction: '',

    // Nueva simulacion
    isLoadingRequest: false,
    showSnackbar: false,
    snackbarColor: 'green',
    snackbarText: '',
    isLoadingSimulacion: false,
    tipoGeometria: null,
    geometria: [],
    fechaInicio: null,
    fechaFin: null,
    numHoras: 8,
    intervaloTiempo: 60,
    halfSide: 10,
    humedadFoliar: 100,
    modelosMeteo: null,
    modeloSeleccionado: null,
    downloadingMeteo: false,
    coordXMeteo: null,
    coordYMeteo: null,
    modelosHumedadFilas: null,
    modelosCombustibleFilas: null,
    meteoDataDowloaded: null,
    condicionErrorBorrar: false,
    borrarError: false
  }),

  computed: {
    ...mapGetters({
      getIncendioByID: 'incendio/getIncendioByID',
      getSimulacionByIncendioID: 'simulacion/getSimulacionByIncendioID'
    }),

    incendio() {
      return this.getIncendioByID(this.idIncendio)
    },

    simulaciones() {
      const simulaciones = this.getSimulacionByIncendioID(this.idIncendio)
      return simulaciones ? (Array.isArray(simulaciones) ? simulaciones : [simulaciones]) : []
    },

    simulacionExists() {
      return this.simulaciones.length > 0
    },

    shouldShowTooltip() {
      return !this.simulacionExists || (this.simulacionSelected && !this.getStatusConfig(this.simulacionSelected.ESTADO).error)
    }

  },

  watch: {
    idIncendio: {
      handler() {
        this.fetchSimulacionesFunction()
        this.reset()
      },
      immediate: true
    }
  },

  mounted() {
    this.rellenarCombustibles()
  },

  methods: {
    ...mapActions('simulacion', [
      'updateSimulacion',
      'addSimulacion',
      'fetchSimulaciones',
      'communicateSimulacion',
      'cerrarSimulacionSlider',
      'deleteSimulacion'
    ]),

    reset() {
      this.simulacionSelected = null
      this.borrarError = false
    },

    startEditing(item) {
      this.editableID = item.ID_SIMULACION
      this.editableText = item.NOMBRE
    },

    async updateName(item) {
      if (!this.editableText || this.editableText === item.NOMBRE) {
        this.stopEditName()
        return
      }
      this.editableText = this.sanitizeNombreArchivo(this.editableText)
      try {
        await this.updateSimulacion({
          id: item.ID_SIMULACION,
          newName: this.editableText
        })
      } catch (error) {
        console.error('Error al actualizar el nombre de la simulacion:', error)
      } finally {
        if (this.simulacionSelected) {
          this.simulacionSelected = null
        }
        this.stopEditName()
      }
    },

    sanitizeNombreArchivo(nombre) {
      return nombre
        .replace(/[<>:"/\\|?*.\n\r\t]/g, '')
        .trim()
    },

    stopEditName() {
      this.editableID = null
      this.editableText = ''
    },

    async fetchSimulacionesFunction() {
      try {
        const fechaHasta = this.$date.now().endOf('day')
        const fechaDesde = this.$date.subtract(fechaHasta, 7, 'days')
        const data = {
          fechaDesde: fechaDesde.format(FMT.dateFetch),
          fechaHasta: fechaHasta.format(FMT.dateFetch)
        }
        await this.fetchSimulaciones(data)
      } catch (error) {
        console.error('Error al cargar simulaciones:', error)
      }
    },

    handleButtonsMethod(item) {
      if (this[item.method]) {
        this[item.method](item.label, item.action)
      } else {
        console.error(`Método ${item.method} no encontrado`)
      }
    },

    async downloadSimulacionVector(label, action) {
      this.itemLabel = label
      this.itemAction = action
      this.showProgress = true

      const responseType = action === 'Download' ? 'blob' : 'json'
      const fileType = label.toUpperCase()

      const warning = await ArcGIS.exportSimulacionBack(this.simulacionSelected, responseType, fileType)
      if (typeof warning === 'number') {
        this.isErrorSimulacion = true
        this.errorSimulacion = warning
        this.showProgress = false
        return
      }
      this.showProgress = false

      if (responseType === 'json') this.$notify(`Link de descarga de ${fileType} copiado al portapapeles`)
    },

    async downloadSimulacionPDF() {
      try {
        const response = await api.simulacion.getSimulationPDF(this.simulacionSelected.ID_SIMULACION)

        ArcGIS.downloadBlob(response.data, `Simulacion_${this.simulacionSelected.ID_SIMULACION}.pdf`)
      } catch (error) {
        console.error('Error descargando el pdf de la simulacion: ', error)
        this.snackbarError('Error descargando el pdf de la simulacion')
      }
    },

    closeDialog() {
      this.$emit('closeDialog')
    },

    async handleSimulacionAction() {
      if (this.simulacionExists) {
        this.closeDialog()
        await this.paintSimulacion(this.simulacionSelected)
        this.borrarError = false
      } else {
        this.generateSimulacion()
      }
    },

    rellenarHumedades(humedad) {
      const fm1 = humedad / 5
      const fm10 = fm1 + 1
      const fm100 = fm1 + 2
      const fmLiveHerb = (fm100 + 1) * 10
      const fmLiveWood = fm1 * 10

      const valoresCalculados = {
        humidity: Math.round(fm1),
        humidity10h: Math.round(fm10),
        humidity100h: Math.round(fm100),
        FLH: Math.round(fmLiveHerb),
        FLW: Math.round(fmLiveWood)
      }

      this.modelosHumedadFilas = Array.from({ length: 14 }, (_, index) => ({
        model: index,
        ...valoresCalculados
      }))
    },

    rellenarCombustibles() {
      const rawModelData = `
      0 0 0 0 0 0
      1 0.74 0 0 0 0
      2 2 1 0.5 0 0.5
      3 3.01 0 0 0 0
      4 5.01 4.01 2 0 5.01
      5 1 0.5 0 0 2
      6 1.5 2.5 2 0 0
      7 1.13 1.87 1.5 0 0.37
      8 1.5 1 2.5 0 0
      9 2.92 0.41 0.15 0 0
      10 3.01 2 5.01 0 2
      11 1.5 4.51 5.51 0 0
      12 4.01 14.03 16.53 0 0
      13 7.01 23.04 28.05 0 15`

      const transformedData = rawModelData
        .trim()
        .split('\n')
        .map(line => {
          const values = line.trim().split(/\s+/).map(Number)
          return {
            FUEL_MODEL_TYPE: values[0],
            H1: values[1],
            H10: values[2],
            H100: values[3],
            LIVE_H: values[4],
            LIVE_W: values[5]
          }
        })
      this.modelosCombustibleFilas = transformedData
    },

    async getModelos(params) {
      try {
        this.$notify('Obteniendo modelos meteorológicos')
        this.modelosMeteo = await (await api.simulacion.getModelsByPosition(params)).data
        this.modelosMeteo.sort((a, b) => {
          const aTieneFecha = a && a.DATE
          const bTieneFecha = b && b.DATE

          if (aTieneFecha && !bTieneFecha) {
            return -1
          }

          if (!aTieneFecha && bTieneFecha) {
            return 1
          }

          return 0
        })

        this.modeloSeleccionado = this.modelosMeteo[0]
      } catch (err) {
        console.error(err)
        throw err
      }
    },

    async downloadMeteo() {
      if (!this.geometria) {
        this.snackbarError('Dibuje la geometría o seleccione las coordenadas')
        return
      }

      this.downloadingMeteo = true

      const x = this.coordXMeteo
      const y = this.coordYMeteo
      const fechaSinMins = `${this.fechaInicio?.substr(0, 14)}00`
      let fixFecha = null
      if (this.fechaInicio) {
        fixFecha = DateService.toDayjs(fechaSinMins, FMT.date).toISOString()
      }

      const params = {
        position: {
          lon: y,
          lat: x
        },
        date: fixFecha,
        duration: this.numHoras,
        model: null
      }

      try {
        if (!this.modelosMeteo) {
          await this.getModelos(params)
        }
        params.model = this.modeloSeleccionado

        this.$notify('Descargando información meteorolágica')
        const response = await api.simulacion.getSimulatorMeteo(params)
        const datos = response.data

        for (let i = 0; i < datos.length; i++) {
          const p = datos[i]

          p.VALORES = p.VALORES.map((v) => Math.round(v * 100) / 100)

          switch (p.ID) {
            case 'temperatura':
              this.meteoData[0].VALORES = p.VALORES
              break
            case 'humedad':
              this.meteoData[1].VALORES = p.VALORES
              break
            case 'nubosidad':
              this.meteoData[2].VALORES = p.VALORES
              break
            case 'viento':
              this.meteoData[3].VALORES = p.VALORES
              break
            case 'direccionViento':
              this.meteoData[4].VALORES = p.VALORES
              break
            case 'precipitacion':
              this.meteoData[5].VALORES = p.VALORES
              break
          }
        }

        this.rellenarHumedades(this.meteoData[1].VALORES[0])
      } catch (err) {
        console.error(err)
        this.snackbarError('Error descargando los datos de meteo')
        this.resetCampos()
      } finally {
        this.downloadingMeteo = false
        this.meteoDataDowloaded = []

        for (let i = 0; i < this.meteoData.length; i++) {
          const prevData = structuredClone(this.meteoData[i].VALORES)
          this.meteoDataDowloaded.push(prevData)
        }
      }
    },

    async generateSimulacion() {
      this.$notify('Generando simulación')
      this.isLoadingRequest = true

      const fechaInicio = this.$date.now().startOf('hour')
      this.fechaFin = this.$date.now().add(this.numHoras, 'hours').format(FMT.date)
      this.fechaInicio = fechaInicio.format(FMT.date)

      const tipoGeometria = [2]

      const center = ArcGIS.convertirLatLonToETRS89(this.incendio.LATITUD, this.incendio.LONGITUD)
      const [x, y] = center

      const puntoParaArcGIS = {
        type: 'point',
        coordinates: [x, y]
      }
      const puntoFinal = await ArcGIS.obtenerCentro(puntoParaArcGIS, 'INCENDIO', 25830)

      const polygonCoords = [
        [x - this.halfSide, y - this.halfSide],
        [x + this.halfSide, y - this.halfSide],
        [x + this.halfSide, y + this.halfSide],
        [x - this.halfSide, y + this.halfSide],
        [x - this.halfSide, y - this.halfSide]
      ]

      this.geometria.push(polygonCoords)
      this.coordXMeteo = this.incendio.LATITUD
      this.coordYMeteo = this.incendio.LONGITUD
      await this.downloadMeteo()
      const meteoData = JSON.parse(JSON.stringify(this.meteoData))
      const municipioSim = `${this.incendio.MUNICIPIO}, Navarra`
      this.modeloSeleccionado.disabled = false

      // No funcionan los minutos en la simulacion asi que hay que ponerlos a 00
      this.fechaInicio = `${this.fechaInicio.substr(0, 14)}00`
      this.fechaFin = `${this.fechaFin.substr(0, 14)}00`

      // Creamos el objeto que pasar al simulador
      const fechaFixInicio = DateService.toDayjs(this.fechaInicio, FMT.date).utc().format(FMT.utcUnderscore)
      const fechaFixFin = DateService.toDayjs(this.fechaFin, FMT.date).utc().format(FMT.utcUnderscore)

      // Creamos el objeto que pasar al simulador
      const datosSimulador = {
        name: `Inicial, ${this.incendio.MUNICIPIO}`,
        observation: '',
        geometry: JSON.parse(JSON.stringify(this.geometria)),
        typeGeometry: tipoGeometria,
        dateInit: fechaFixInicio,
        dateEnd: fechaFixFin,
        timeStep: this.intervaloTiempo,
        useWindNinja: 0,
        firewall: [],
        typeFirewall: [],
        useFirewall: 0,
        meteoData,
        useCustomMeteo: 0,
        fuelModel: [],
        fuelModelArea: [],
        municipality: municipioSim,
        simulationCenter: puntoFinal,
        fuelModelDefinition: this.modelosHumedadFilas,
        fuelModelLoads: this.modelosCombustibleFilas,
        crownFlag: 0,
        foliarMoisture: this.humedadFoliar,
        crownFireFinney: 1,
        selectedModel: this.modeloSeleccionado
      }

      // Creamos el objeto para insertar en BDD
      const datosBackend = {
        FECHA_CREACION: this.$date.now(),
        FECHA_INICIO: this.$date.parseDate(
          this.fechaInicio,
          FMT.date
        ),
        NUM_HORAS: this.numHoras,
        INTERVALO: this.intervaloTiempo,
        NOMBRE: `Inicial, ${this.incendio.MUNICIPIO}`,
        VIENTOS: 0,
        GRAFICOS: [],
        ID_INCENDIO: this.incendio.ID_INCENDIO
      }

      const data = {
        datosSimulador,
        tipo: 'INCENDIO',
        datosBackend
      }

      try {
        await this.addSimulacion(data)
        this.snackbarSuccess('Simulación solicitada correctamente')
      } catch (err) {
        console.error(err)
        this.snackbarError('Error solicitando simulación')
        await this.deleteSimulacionButton()
      } finally {
        this.resetCampos()
        this.isLoadingRequest = false
      }
    },

    resetCampos() {
      this.$emit('endSimulacionSketch')
      this.geometria = null
      this.sim = null
      this.fechaInicio = this.$date.currentDate()
      this.borrarError = false
    },

    snackbarError(msg) {
      this.showSnackbar = true
      this.snackbarColor = 'error'
      this.snackbarText = msg
    },

    snackbarSuccess(msg) {
      this.showSnackbar = true
      this.snackbarColor = 'success'
      this.snackbarText = msg
    },

    async paintSimulacion(simulacion) {
      if (this.sim) { ArcGIS.clearSimulacion(this.sim) }
      this.sim = {
        id: null,
        idIncendio: this.idIncendio,
        simulacion,
        isocronas: [],
        longitudLlama: [],
        intensidadLlama: [],
        velocidadPropagacion: [],
        graficosSimulacion: [],
        coordenadas: []
      }

      await this.communicateSimulacion({
        id: 'simulacion',
        sim: this.sim
      })
    },

    estadoProgres(item) {
      if (!item?.ESTADO) return false

      const config = this.getStatusConfig(item.ESTADO)

      return config.p < 100 || config.error
    },

    getStatusConfig(estado) {
      const map = {
        // Estados de Error
        ERROR: { p: 100, error: true },
        ERROR_REPORT_IGP: { p: 100, error: true },
        ERROR_CATASTRO: { p: 100, error: true },
        ERROR_IGP: { p: 100, error: true },
        ERROR_REPORT: { p: 100, error: true },
        TIME_OUT: { p: 100, error: true },

        // Estados de Progreso
        NEW: { p: 5, error: false },
        PREPROCESSING: { p: 15, error: false },
        GENERATING_INPUTS: { p: 25, error: false },
        SIMULATING: { p: 45, error: false },
        PROCESSING: { p: 60, error: false },
        PROCESSING_IGP: { p: 70, error: false },
        PROCESSING_CATASTRO: { p: 80, error: false },
        PROCESSING_REPORT: { p: 85, error: false },
        POSTPROCESSING: { p: 90, error: false },

        // Estados Finalizados
        COMPLETED: { p: 100, error: false },
        COMPLETED_CATASTRO: { p: 100, error: false },
        COMPLETED_REPORT: { p: 100, error: false }
      }

      return map[estado] || { p: 0, error: false }
    },

    selectSimulacion(item) {
      if (this.simulacionSelected && this.simulacionSelected.ID_SIMULACION === item.ID_SIMULACION) {
        this.simulacionSelected = null
      } else {
        this.simulacionSelected = item
      }
    },

    async deleteSimulacionButton() {
      const simulacion = this.simulacionSelected

      if (!simulacion) return

      try {
        await this.deleteSimulacion(simulacion)
        this.simulacionSelected = null
        this.snackbarSuccess('Simulación borrada correctamente')
        this.fetchSimulacionesFunction()
      } catch (error) {
        console.error(error)
        this.snackbarError('Error al borrar la simulacion')
      } finally {
        this.simulacionSelected = null
        this.borrarError = false
      }
    },

    borrarSimulacionError(item) {
      if (this.borrarError) {
        this.borrarError = false
        this.simulacionSelected = null
      } else {
        this.borrarError = true
        this.simulacionSelected = item
      }
    }
  }
}
</script>
<style scoped>
.selected-row {
  background-color: #f5f5f5;
}

.select-button {
  margin-right: 0.5rem;
}
</style>
